import {
  REGISTER,
  SUCCESSFUL_REG,
  FAILURE_REG,
  SAVE_ACCOUNT_ID
} from '../constants/actionTypes';
import {
       STATUS_ERROR,
     STATUS_OK } from '../constants/reponseTypes';
import { ACTIVATION_URL } from '../constants/restURLs';
import { fetchApi } from '../api';
import { push } from 'react-router-redux'

export function activate(accountId, activationCode) {
  return function (dispatch) {
    let lang = localStorage.getItem('lang');
    let params = "accountId=" + accountId + "&activationCode=" + activationCode;
    console.log("params", params);
    let callbacks = {
      onSuccess: (response) => {
        console.log('onSuccess:');
        console.log('sign up response', response);
        if ( response.status == STATUS_OK ){
          dispatch(push('/welcome'));
        }else{
          alert(response.message);
          return;
        }
      },
      onFailed: (response, statusCode) => {
        console.log('onFailed:');
        alert(response.message);
      },
      onError: (error) => {
        console.log('onError:');
      }
    }
    fetchApi(dispatch, ACTIVATION_URL, params, callbacks);
  };
}



// WEBPACK FOOTER //
// ./src/actions/activateActions.js